<template>
    <b-modal
        id="modal-itemstockselector"
        ref="modal"
        size="xl"
        :title="this.formtitle"
        :visible="visible"
        @hidden="hide"
        @ok="handleOk"
        @change="change"
    >
        <b-card @submit.stop.prevent="handleSubmit">
            <b-alert
                v-model="showDismissibleAlert"
                variant="danger"
                dismissible
            >
                {{ alertText }}
            </b-alert>
            <b-input-group :prepend="$t('com_kaassoort', { ns: 'common' })">
                <lookup-combo
                    :placeholder="
                        $t('com_kaassoort', {
                            ns: 'common'
                        })
                    "
                    v-model="selectedProductID"
                    v-bind:combotype="lctypeCheeses"
                    :disabled="true"
                ></lookup-combo>
                <lookup-combo
                    :placeholder="
                        $t('prod_vorm', {
                            ns: 'production'
                        })
                    "
                    v-model="selectedShapeID"
                    v-bind:combotype="lctypeShapes"
                    :disabled="true"
                ></lookup-combo>
            </b-input-group>

            <b-table
                striped
                responsive
                :fields="visibleFields"
                :items="displayList"
                multi
                selectable
                ref="prodTable"
                @row-selected="onRowSelected"
            >
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                        <span aria-hidden="true">&check;</span>
                        <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">Not selected</span>
                    </template>
                </template>
            </b-table>
            <p>
                <b-button
                    size="sm"
                    v-if="erisselected"
                    @click="clearSelected"
                    >{{
                        $t('com_wisselectie', {
                            ns: 'common'
                        })
                    }}</b-button
                >
            </p>
        </b-card>
    </b-modal>
</template>
<script>
import DateHelper from '../../models/DateHelper';
import Helper from '../../models/Helper';
import { loadList, loadItem } from '../../models/DataHelper';
import { LookupCombo } from '../components';
export default {
    name: 'ItemStockSelector',
    data: function () {
        return {
            lctypeCheeses: window.constants.LCCHEESE,
            lctypeShapes: window.constants.LCSHAPES,
            selectedProductID: null,
            selectedShapeID: null,
            showDismissibleAlert: false,
            alertText: '',
            selected: [],
            forcerefresh: true,
            datum: new Date(),
            displayList: [],
            selectedObject: null
        };
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        askedShapeID: {},
        askedProductID: {},
        requestedAmount: {},
        title: {
            type: String,
            default: ''
        }
    },
    watch: {},
    components: { LookupCombo },
    computed: {
        formtitle() {
            return this.title;
        },
        erisselected() {
            return this.selected.length > 1;
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'selected', label: ' ', sortable: false, visible: true },
                { key: 'actions', label: ' ', visible: false },
                {
                    key: 'batchID',
                    label: this.$t('com_batch', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'productiedatum',
                    label: this.$t('com_production', {
                        ns: 'common'
                    }),
                    sortable: true,
                    visible: true,
                    formatter: (value, key, item) => {
                        const temp = DateHelper.convertedToDate(
                            item.productiedatum
                        );
                        return temp;
                    }
                },
                {
                    key: 'cheeseage',
                    label: this.$t('prod_leeftijd', {
                        ns: 'production'
                    }),
                    sortable: true,
                    visible: true,
                    formatter: (value, key, item) => {
                        const temp = item.leeftijdKlasse;
                        return temp
                            ? item.leeftijdKlasse +
                                  ' (' +
                                  item.leeftijdDagen +
                                  ')'
                            : '';
                    }
                },
                {
                    key: 'aantalstart',
                    label: this.$t('com_amount', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'assigned',
                    label: this.$t('prod_assigned', { ns: 'production' }),
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        }
    },
    methods: {
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        hide() {
            this.$emit('hide');
        },
        async checkFormValidity() {
            if (this.selected.length === 0) {
                this.showAlert(
                    this.$t('com_geen_data', {
                        ns: 'common'
                    })
                );
                return false;
            }
            let gaDoor = true;
            let warnString = '';
            for (let i = 0; i < this.selected.length; i++) {
                const item = this.selected[i];
                const opVoorraad = item.aantalstart - (item.assigned ?? 0);
                const marge = opVoorraad - this.requestedAmount;
                if (marge < 0) {
                    warnString = Helper.concatString(
                        warnString,
                        Helper.stringformat(
                            this.$t('prod_meerdanvoorraad', {
                                ns: 'production'
                            }),
                            this.requestedAmount,
                            opVoorraad
                        )
                    );
                }
            }
            if (warnString != '') {
                gaDoor = await this.$root.showConfirmationBox(warnString);
            }
            return gaDoor;
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            // Trigger submit handler
            this.handleSubmit();
        },
        async handleSubmit() {
            if (!(await this.checkFormValidity())) {
                return;
            }
            // Hide the modal manually
            this.$nextTick(() => {
                this.$emit(
                    'input',
                    this.selected.map((x) => x.id)
                );
                this.$bvModal.hide('modal-itemstockselector');
            });
        },
        async findStock() {
            this.clearSelected();
            const lijstStock = await loadList(
                'stock/getStockInfo',
                'stock/loadStockInfo',
                null,
                this.forcerefresh,
                this.$t
            );
            this.displayList = [];
            let tempi = [];
            if (
                this.askedProductID != undefined &&
                this.askedShapeID != undefined
            ) {
                tempi = lijstStock.filter(
                    (x) =>
                        x.productID == this.askedProductID &&
                        x.vormID == this.askedShapeID
                );
            } else {
                if (this.askedProductID != undefined) {
                    tempi = lijstStock.filter(
                        (x) => x.productID == this.askedProductID
                    );
                } else {
                    tempi = lijstStock;
                }
            }
            if (tempi.length == 0) return;
            tempi.map((x) => (x.aantalstart = x.aantal));

            const lijstAssigned = await loadItem(
                'salesorder/loadAssignedSalesOrderStockInfo',
                { productID: this.askedProductID, shapeID: this.askedShapeID },
                this.$t
            );
            if (lijstAssigned.length > 0) {
                for (let i = 0; i < tempi.length; i++) {
                    const item = tempi[i];
                    const shortlist = lijstAssigned.filter(
                        (x) => x.lotnummer == item.batchID
                    );
                    const assigned = shortlist
                        .map((x) => x.assigned)
                        .reduce((temp, a) => temp + a, 0);
                    const aantalstart = shortlist
                        .map((x) => x.aantalstart)
                        .reduce((temp, a) => temp + a, 0);
                    if (assigned > 0) {
                        item.aantalstart = aantalstart;
                        item.assigned = assigned;
                    }
                }
            }
            this.displayList = tempi.sort((a, b) => {
                return new Date(b.productiedatum) - new Date(a.productiedatum);
            });
        },
        onRowSelected(items) {
            this.selected = items;
        },
        clearSelected() {
            this.selectedObject = null;
            if (this.$refs.prodTable) this.$refs.prodTable.clearSelected();
        },
        change(visible) {
            this.$emit('change', visible);
        }
    },
    mounted() {},
    async created() {
        this.selectedProductID = this.askedProductID;
        this.selectedShapeID = this.askedShapeID;
        await this.findStock();
    }
};
</script>

<style scoped>
::v-deep .table > tbody > tr.b-table-row-selected,
::v-deep .table > tbody > tr.b-table-row-selected > td,
::v-deep .table > tbody > tr.b-table-row-selected > th {
    background-color: #00a1de;
    color: ghostwhite !important;
}
.overflow-class /deep/ .dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
}
</style>

